<!--begin header -->
<header class="header">
    <app-header></app-header>
</header>
<!--end header -->
<!--begin section-grey -->
<section class="section-white pb-3 page-content">
    <!--begin services-wrapper -->
    <div class="services-wrapper">
        <!--begin container -->
        <div class="container">
            <div class="row">
                <div class="col-12 mb-2">
                    <h1  class="text-orange about">About Us:</h1>
                    <p>An established Payment Services company, headquartered in Singapore.
                        Founded by a group of
                        ex-bankers, the Company is changing the way cross border payments are made.
                        We began operations 5 years ago. Customers have trusted us with billions in transactions
                        already. The company has been the recipient of multiple industry awards, including the MAS
                        (Monetary Authority of Singapore) Fintech award in 2017 and is ranked amongst the top 5 cross
                        border payment providers in Singapore.
                    </p>
                    <p>We have live operations in 3 major financial centres (Singapore, Hong Kong and Australia). Our
                        payment coverage includes over 180 countries and operates 7 days a week and we created a strong
                        global coverage and presence. 365 days a year. We have an experienced management team that
                        understands the need to judiciously balance innovation and regulatory demands.</p>
                    <p>Our Core Value Proposition is Cheaper, Faster, More Convenient payments. We offer 100% Digital
                        Solutions delivered off a world class technology platform. Our service offering includes:
                    </p>
                    <ol style="list-style-type: decimal-leading-zero;">
                        <li><a>1. Consumer Solutions</a></li>
                        <li><a>2. Business Solutions</a></li>
                        <li><a>3. Solutions for banks and payment intermediaries</a></li>
                    </ol>
                    <p>We pride ourselves in providing impeccable customer service, ownership, and resolution of any
                        customer concerns at lightning speed and strive in the success of our customers.
                    </p>
                    <div class="col-12 mb-2"></div>
                    <h2 class="text-orange consol" id="consumersolution">Consumer Solutions</h2>
                    <p>Individual consumers can open an account with us in minutes and get access to a SingX wallet and
                        a
                        payment platform that enables them to make instant payments to over 180 countries, 7 days a
                        week.</p>
                    <p>Banks levy a variety of fees including cable charges, handling charges and correspondent banking
                        charges. Besides they mark up the foreign exchange rates. These charges all add up and customers
                        end
                        up paying 5% more than they should. With SingX they book transactions at the live interbank
                        rate, a
                        rate which can be easily verified on Google anytime. We charge one transparent fee which is made
                        known upfront. In summary, customers enjoy guaranteed savings.</p>
                    <p>The SingX wallet allows consumers the facility to recharge their mobile phones anywhere in the
                        world
                        and pay utility bills back home. For instance, an Australian travelling to Dubai can top up his
                        Dubai mobile on our app with a single click. Similarly, an Indian living in Singapore can view
                        her
                        Indian electricity bill or Indian property tax bill on our app. They can then proceed to pay
                        this
                        INR denominated bill using their wallet instantly.
                    <a routerLink="/">Find Out More </a></p>
                    <div class="col-12 mb-2"></div>
                    <h2  class="text-orange consol" id="consumersolution">Business Solutions</h2>
                    <p>The Company offers a comprehensive package of business solutions catering to the needs of SMEs
                        and
                        mid to large corporates. We are a “one-stop shop” which manages all payments to overseas
                        suppliers
                        and employees, as well as for cross-border inter-company transfers.</p>

                        <h5 class="text-orange" id="consumersolution">Our business solutions:</h5>
                        <ul class="text">
                            <li><i class="fas fa-dot-circle" ></i> Meet the payments needs of
                                Importers/Exporters</li>
                            <li><i class="fas fa-dot-circle" ></i>Offer Embedded Finance
                                solutions to cloud workforce
                                platforms paying salaries to gig workers and
                                e-commerce marketplaces paying suppliers</li>
                            <li><i class="fas fa-dot-circle" ></i>Offer Mass Payment solutions
                                to Corporates paying Salaries
                                and Suppliers</li>
                        </ul>

                    <p>
                        Our core value proposition is to offer Businesses guaranteed savings on Payments and reduced
                        operational costs for managing payments and receivables. Businesses can either book transactions
                        on
                        an ad hoc basis, or if they prefer, use our fully automated pay out solutions via our Mass
                        Payment
                        tools. With these tools, once the receivers are set up, regular repeat payments can be done
                        easily
                        at very attractive rates.
                        <a href="https://business.singx.co" alt="">Find Out More </a>
                    </p>
                    <div class="col-12 mb-2"></div>
                    <h3  class="text-orange banksol" id="consumersolution">Solutions for banks and payment intermediaries</h3>
                    <p>Many banks and payment intermediaries want to offer digitized payment solutions to their
                        customers.
                        We offer white labelled solutions, API services and a global pay out network to enable these
                        payments. Our solutions are flexible and can be easily integrated. These solutions incorporate
                        all
                        the features and benefits of the consumer and business solutions described above.</p>

                        <div class="col-12 mb-2"></div>
                </div>
            </div>
        </div>
        <!--end container -->
    </div>
    <!--end services-wrapper -->
</section>
<!--end section-grey -->
<app-footer></app-footer>